import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PhabButton from './PhabButton';

import * as constants from './constants';

import './phab.scss';

import { PlusChunky } from '@eb/eds-iconography';

const PhabListItem = ({ title, iconType, index, onClick, show }) => {
    const className = classNames(
        'eds-phab__list__item',
        'eds-l-pad-hor-1',
        'eds-l-pad-bot-4',
        'eds-fx--duration_-5',
        `eds-fx--delay-${index}`,
        {
            'eds-fx--fade-in-up': show,
        },
    );

    return (
        <li className={className} data-spec="eds-phab-list-item">
            <PhabButton
                style="neutral"
                iconType={iconType}
                title={title}
                size="small"
                onClick={onClick}
            />
        </li>
    );
};

export default class Phab extends React.PureComponent {
    static propTypes = {
        /**
         * Array of list items.
         */
        items: constants.ITEMS_PROP_TYPE.isRequired,
        /**
         * Changes the style of the phab.
         * Available styles: neutral, fill
         */
        style: PropTypes.oneOf(constants.STYLES),
        /**
         * The type of icon that you want to display e.g. alert
         */
        primaryIconType: constants.ICON_TYPES,
        /**
         * Show / Hide items
         */
        initialShowItems: PropTypes.bool,
        /**
         * Callback function invoked when an item button is clicked.
         * (index) => {  }
         */
        onItemClick: PropTypes.func,
        /**
         * Callback function invoked when the button is clicked.
         */
        onShowItemsChange: PropTypes.func,
    };

    static defaultProps = {
        style: constants.STYLE_FILL,
        primaryIconType: <PlusChunky />,
    };

    constructor(props) {
        super(props);

        const { initialShowItems } = props;

        this.state = {
            showItems: initialShowItems,
        };
    }

    _handleItemClick(index) {
        const { onItemClick } = this.props;

        if (onItemClick) {
            onItemClick(index);
        }
    }

    _handleToggleShowItems() {
        this.setState(
            ({ showItems: prevShowItems }) => ({ showItems: !prevShowItems }),
            () => {
                if (this.props.onShowItemsChange) {
                    this.props.onShowItemsChange(this.state.showItems);
                }
            },
        );
    }

    _getSecondaryPhabs(items) {
        const { showItems } = this.state;

        return items
            .map(({ title, iconType }, index) => (
                <PhabListItem
                    key={iconType + title}
                    title={title}
                    iconType={iconType}
                    index={index}
                    onClick={this._handleItemClick.bind(this, index)}
                    show={showItems}
                />
            ))
            .reverse();
    }

    _getPhabList(items, showItems) {
        const className = classNames(
            'eds-phab__list',
            'eds-l-pad-bot-2',
            'eds-fx--duration_2',
            {
                'eds-fx--fade-out-down': !showItems,
            },
        );

        return (
            <ul className={className} data-spec="eds-phab-list">
                {this._getSecondaryPhabs(items)}
            </ul>
        );
    }

    render() {
        const { style, primaryIconType, items } = this.props;

        const { showItems } = this.state;

        const className = classNames('eds-phab', {
            'eds-phab--open': showItems,
        });

        return (
            <div className={className}>
                {this._getPhabList(items, showItems)}
                <PhabButton
                    style={style}
                    iconType={primaryIconType}
                    onClick={this._handleToggleShowItems.bind(this)}
                />
            </div>
        );
    }
}
